import DealRoomContextProvider from './DealRoom.provider';

export default DealRoomContextProvider;
